import { MouseEvent } from 'react';
import { IconButton, Toolbar } from '@material-ui/core';

import { ArrowBackIcon, CloseIcon } from '#root/icons';
import styles from './styles.module.scss';

interface DrawerAppbarProps {
  isMobile?: boolean;
  title?: string;
  // Línea secundaria bajo el título (ej. la sección desde donde se abrió el drawer)
  subtitle?: string;
  onClose: (e?: MouseEvent<HTMLElement>) => void;
}

const DrawerAppbar = (props: DrawerAppbarProps) => {
  const { isMobile, title, subtitle, onClose } = props;

  return (
    <div className={styles.root}>
      <Toolbar>
        {isMobile && (
          <IconButton onClick={onClose}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <div className={styles.heading}>
          <h6 className={styles.title}>{title}</h6>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {!isMobile && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Toolbar>
    </div>
  );
};

export default DrawerAppbar;
